import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";

import "../css/PopupRegisterCancellation.css";

import ButtonIconH from "../../components/ButtonIconH";
import InputTextArea from "../../components/InputTextArea";
import { post } from "../../js/post";
import { userData } from "../../js/utils";

const columns = [
  { name: "Fecha", selector: (row) => row.fecha, width: "20%" },
  { name: "Agente", selector: (row) => row.agente, width: "40%" },
  {
    name: "Inicio",
    selector: (row) => row.inicio,
    center: true,
    width: "10%",
  },
  { name: "Fin", selector: (row) => row.fin, center: true, width: "10%" },
  { name: "Tipo", selector: (row) => row.tipo, width: "20%" },
];

export default ({
  show,
  idRegistro,
  fecha,
  agente,
  inicio,
  fin,
  tipo,
  tipoRegistro,
  onCancel,
  onAccept,
  createPopupQuestion,
  removePopupQuestion,
}) => {
  const [motivo, setMotivo] = useState("");
  const [cancelling, setCancelling] = useState(false);

  const cancel = () => {
    onCancel();
  };

  const anular = async () => {
    if (!motivo) {
      createPopupQuestion(
        "Debe introducir un motivo.",
        removePopupQuestion,
        null,
        "Entendido",
      );
      return;
    }

    setCancelling(true);
    await post("AnularRegistroJornada.php", {
      token: userData.token,
      idRegistro,
      tipo: tipoRegistro,
      motivo,
    });
    setCancelling(false);

    createPopupQuestion(
      "Registro anulado de manera correcta. Analice si esta anulación requiere de una nueva declaración de registro.",
      () => {
        removePopupQuestion();
        onCancel();
        onAccept();
      },
      null,
      "Cerrar",
    );
  };

  useEffect(() => {
    if (show) {
      setMotivo("");
    }
  }, [show]);

  return show ? (
    <div className="popup-container popup-normal popup-registercancellation">
      <div className="popup-message">
        <div className="popup-header">
          <div className="popup-title">Anulación de registro</div>
          <img
            src="/images/close-white.svg"
            loading="lazy"
            alt=""
            className="popup-close"
            onClick={cancel}
          />
        </div>
        <div className="popup-body">
          <div className="popup-body-registercancellation">
            <div className="popup-registercancellation-section-title">
              Registro que se va a anular
            </div>
            <DataTable
              columns={columns}
              data={[{ fecha, agente, inicio, fin, tipo }]}
              className="custom-datatable"
            />
            <div className="popup-registercancellation-section-title">
              Motivo de la anulación
            </div>
            <InputTextArea
              id="popup-registercancellation-motivo"
              size={0}
              rows={4}
              maxLength={150}
              upperCase={true}
              input={motivo}
              onChange={setMotivo}
            />
          </div>
        </div>
        <div className="popup-footer">
          <div className="popup-row-buttons">
            <ButtonIconH text="Anular" disabled={cancelling} onClick={anular} />
            <ButtonIconH
              text="Cancelar"
              disabled={cancelling}
              onClick={cancel}
            />
          </div>
        </div>
      </div>
    </div>
  ) : null;
};
